// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SELLER_SEARCH_LIKED_LABEL = "Moji ob\u013e\u00faben\u00ed";
export const BZ2_SELLER_SEARCH_MOVED = "<strong>H\u013eada\u0165 predajcov</strong> m\u00f4\u017ee\u0161 na <a href=\"/market\">hlavnej str\u00e1nke baz\u00e1ra</a>, sta\u010d\u00ed da\u0165 pred prihlasovacie meno zavin\u00e1\u010d (@loginpredajcu).";
export const BZ2_SELLER_SEARCH_SHOW_MORE = "Zobraz \u010fal\u0161\u00edch predajcov...";
